import { useState, useReducer, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
// import Footer from "../Components/common/footer";
import WPLetterTemplate from "../Components/WordProcessor/WPLetterTemplate";
import WPGenerateDocument from "../Components/WordProcessor/WPGenerateDocument";
import WPDiscoveryDraft from "../Components/WordProcessor/WPDiscoveryDraft";
import SelectDoc from "../Components/WordProcessor/selectDoc";
import WPCourtForm from "../Components/WordProcessor/WPCourtForm";
import { getCaseId, getClientId } from "../Utils/helper";
import { useFooter } from "../Components/common/shared/FooterContext";
import FooterWP from "../Components/common/footer-wp";
import { getFirmManagementUrl } from "../Routes/firmManagement.mjs";

function WordProcessor() {
  const [searchParams] = useSearchParams();
  const docId = searchParams.get("docId");
  const updatedDocId = searchParams.get("updatedDocId");
  const dynamicTemplateId = searchParams.get("dynamic_template_id");
  const editDocId = searchParams.get("editDocId");
  const initialExpiresAt = searchParams.get("expiresAt");
  const type = searchParams.get("type");
  const draftId = searchParams.get("draftId");
  const isFromLetterPopup = searchParams.get("isFromLetterPopup") === "true";

  const courtFormId = searchParams.get("court_form_id");

  const redirectUrl = decodeURIComponent(searchParams.get("redirect_url"));

  const { setFooterState } = useFooter();

  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthorizationToken();
  const [countdown, setCountdown] = useState(5); // Initialize countdown to 5 seconds
  const litigationId = searchParams.get("litigation_id");
  const [showRightSidebar, setShowRightSidebar] = useState(false);
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const container = useRef(null);

  const initialState = {
    filename: "",
    updatedFileName: "",
    show: false,
    loading: true,
    error: false,
    status: "",
    draftId: "",
    tempName: "",
  };

  function reducer(state, action) {
    switch (action.type) {
      case "SET_LOADING":
        return { ...state, loading: action.payload };
      case "SET_ERROR":
        return { ...state, error: action.payload };
      case "SET_FILENAME":
        return { ...state, filename: action.payload };
      case "SET_UPDATED_FILENAME":
        return { ...state, updatedFileName: action.payload };
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };
      case "SET_DRAFT_ID":
        return { ...state, draftId: action.payload };
      case "SET_TEMP_NAME":
        return { ...state, tempName: action.payload };
      default:
        return state;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [zoomScale, setZoomScale] = useState(1);

  // useEffect(() => {
  //   if (container.current) {
  //     // Update total pages when document loads
  //     const editor = container.current.documentEditor;

  //     // Listen for page count changes
  //     const updatePageCount = () => {
  //       const pages = editor.pageCount;
  //       setTotalPages(pages);
  //     };

  //     // Listen for selection changes to update current page
  //     const updateCurrentPage = () => {
  //       const currentPage = editor.selection.startPage;
  //       setPageNumber(currentPage);
  //     };

  //     // Initial setup
  //     updatePageCount();
  //     updateCurrentPage();
  //   }
  // }, [container]);
  const getPageCount = () => {
    if (!container.current) return 1;

    // Try the direct method first
    const direct = container.current.getTotalPages?.();
    if (direct && direct > 1) return direct;

    // Fall back to layout engine
    const editorRef = container.current.getEditorRef?.();
    const layout = editorRef?.getLayout?.();
    if (layout?.pages?.length) return layout.pages.length;

    return 1;
  };
  useEffect(() => {
    if (!container.current) return;

    // Initial values after editor is ready
    const total = getPageCount();
    const current = container.current.getCurrentPage?.();
    if (total) setTotalPages(total);
    if (current) setPageNumber(current);
  }, [container]);

  const renderContent = () => {
    switch (type) {
      case "LetterTemplate":
        return (
          <WPLetterTemplate
            updatedDocId={updatedDocId}
            docId={docId}
            dynamicTemplateId={dynamicTemplateId}
            editDocId={editDocId}
            initialExpiresAt={initialExpiresAt}
            dispatch={dispatch}
            state={state}
            container={container}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "GenerateDocument":
        return (
          <WPGenerateDocument
            updatedDocId={updatedDocId}
            docId={docId}
            dynamicTemplateId={dynamicTemplateId}
            dispatch={dispatch}
            draftId={draftId}
            state={state}
            fetchEditDocs={fetchEditDocs}
            type={type}
            isFromLetterPopup={isFromLetterPopup}
            container={container}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "Draft":
        return (
          <WPGenerateDocument
            updatedDocId={updatedDocId}
            docId={docId}
            dynamicTemplateId={dynamicTemplateId}
            dispatch={dispatch}
            draftId={draftId}
            state={state}
            fetchEditDocs={fetchEditDocs}
            type={type}
            isFromLetterPopup={isFromLetterPopup}
            container={container}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "DiscoveryDraft":
        return (
          <WPDiscoveryDraft
            updatedDocId={updatedDocId}
            docId={docId}
            dynamicTemplateId={dynamicTemplateId}
            dispatch={dispatch}
            draftId={draftId}
            state={state}
            fetchEditDocs={fetchEditDocs}
            type={type}
            litigationId={litigationId}
            showRightSidebar={showRightSidebar}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "selectDoc":
        return (
          <SelectDoc
            dynamicTemplateId={dynamicTemplateId}
            redirectUrl={redirectUrl}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "CourtForm":
        return (
          <WPCourtForm
            updatedDocId={updatedDocId}
            docId={docId}
            courtFormId={courtFormId}
            dispatch={dispatch}
            draftId={draftId}
            state={state}
            fetchEditDocs={fetchEditDocs}
            type={type}
            litigationId={litigationId}
            showRightSidebar={showRightSidebar}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      // case "CourtFormVariable":
      //   return <WPCourtFormVariable updatedDocId={updatedDocId}  docId={docId} courtFormId={courtFormId} litigationId={litigationId} courtFormName={courtFormName} />;

      default:
        return <p>Select an option to get started</p>;
    }
  };

  const fetchEditDocs = async () => {
    try {
      const response = await axios.get(`${origin}/api/create-edit-doc/`, {
        headers: { Authorization: token },
      });

      if (response.status === 200) {
        const data = response.data;
        setFooterState(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  const redirectToFirmSetting = async () => {
    if (type === "LetterTemplate" && !state.status.includes("renamed")) {
      const redirect_url = getFirmManagementUrl(getClientId(), getCaseId(), "templates");
      window.location.href = redirect_url;
    } else if (
      (type === "GenerateDocument" || type === "Draft") &&
      !state.status.includes("renamed") &&
      !state.status.includes("Attached To Case")
    ) {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    } else if (type === "CourtForm" || type === "DiscoveryDraft") {
      const redirect_url = "/bp-litigation/" + getClientId() + "/" + getCaseId();
      window.location.href = redirect_url;
    }
  };

  useEffect(() => {
    if (state.show) {
      setCountdown(5);

      const timer = setTimeout(() => {
        dispatch({ type: "HIDE_MODAL" });
        redirectToFirmSetting();
      }, 5000);

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
  }, [state.show, dispatch]);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <NavBar flaggedPageName={1} />
          <div
            className="row mx-auto w-100"
            id="padding-top-165"
            style={{
              height: "100%",
            }}
          >
            {type === "CourtFormVariable" ? (
              <ActionBarComponent
                src="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/courtforms.svg"
                page_name={"Court Form"}
              />
            ) : (
              <ActionBarComponent
                src={
                  type === "LetterTemplate"
                    ? "https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/edit-template-icon.svg"
                    : "https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/documents-icon-color.svg"
                }
                page_name={
                  type === "LetterTemplate"
                    ? `Editing Document Template: ${state?.tempName}`
                    : state.tempName ||
                      (type === "CourtForm"
                        ? "Court Form Editor"
                        : type === "DiscoveryDraft"
                          ? "Discovery Draft Editor"
                          : "Word Processor")
                }
                showRightSidebar={showRightSidebar}
                setShowRightSidebar={setShowRightSidebar}
              />
            )}

            {renderContent()}
          </div>
        </div>
      </div>

      <Modal
        show={state.show}
        onHide={() => {
          dispatch({ type: "HIDE_MODAL" });
          redirectToFirmSetting();
        }}
      >
        <Modal.Header>
          <Modal.Title>{state.status}</Modal.Title>
        </Modal.Header>
        <Modal.Footer
          className="mt-0"
          style={{
            borderTop: "none",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            variant="secondary"
            onClick={() => {
              dispatch({ type: "HIDE_MODAL" });
              redirectToFirmSetting();
            }}
            style={{ marginBottom: "10px" }} // Adds space between button and countdown text
          >
            Dismiss
          </Button>
          <div style={{ textAlign: "center", fontSize: "0.9rem" }}>
            Automatically closing in {countdown} seconds...
          </div>
        </Modal.Footer>
      </Modal>

      <FooterWP
        container={container}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        zoomScale={zoomScale}
        setZoomScale={setZoomScale}
      />
    </>
  );
}

export default WordProcessor;
